import { render } from "./GameDetailsModal.vue?vue&type=template&id=e3ed5f1a&scoped=true&ts=true"
import script from "./GameDetailsModal.vue?vue&type=script&lang=ts"
export * from "./GameDetailsModal.vue?vue&type=script&lang=ts"

import "./GameDetailsModal.vue?vue&type=style&index=0&id=e3ed5f1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ed5f1a"]])

export default __exports__